import SubmissionInstructionModalComponent from './submission-instruction-modal.component'

const SubmissionInstructionModalModule = angular.module('cdbl.submission-instruction-modal', [

])
  .component('cdblSubmissionInstructionModal', SubmissionInstructionModalComponent)
  .name

export default SubmissionInstructionModalModule
